<template>
  <div class="app-checkout-customer-data">
    <div class="customer-data--header"><slot name="txtHeadline">Lorem ipsum dolor sit amet.</slot></div>
    <div class="customer-data--form">
      <b-form id="customer-data-form" :novalidate="true">
        <div class="form--block">
          <h2 class="h3"><slot name="lblAddressHeadline">Lorem ipsum.</slot></h2>
          <GenderRadioInput
            :gender.sync="person_.gender"
            :invalid.sync="invalid.gender"
            ref="nestedInputGender"
          >
            <template v-for="slot in possibleChildSlotsFor('Gender')" v-slot:[`${slot.child}`]>
              <slot :name="`${slot.parent}`"></slot>
            </template>
            <template v-for="slotError in possibleChildSlotsFor('Error')" v-slot:[`${slotError.child}`]><slot :name="`${slotError.parent}`"></slot></template>
          </GenderRadioInput>
          <div class="form-row">
            <LabeledTextInput
              name="firstName"
              :model.sync="person_.firstName"
              :invalid.sync="invalid.firstName"
              :validation="validations.person.firstName"
              :formatter="formatterCharFilterOnlyAplha"
              :mandatory="true"
              width="33"
              ref="nestedInputFirstName"
            >
              <template v-for="slot in possibleChildSlotsFor('FirstName')" v-slot:[`${slot.child}`]><slot :name="`${slot.parent}`"></slot></template>
              <template v-for="slotError in possibleChildSlotsFor('Error')" v-slot:[`${slotError.child}`]><slot :name="`${slotError.parent}`"></slot></template>
            </LabeledTextInput>
            <LabeledTextInput
              name="lastName"
              :model.sync="person_.lastName"
              :invalid.sync="invalid.lastName"
              :mandatory="true"
              :validation="validations.person.lastName"
              :formatter="formatterCharFilterOnlyAplha"
              width="33"
              ref="nestedInputLastName"
            >
              <template v-for="slot in possibleChildSlotsFor('LastName')" v-slot:[`${slot.child}`]>
                <slot :name="`${slot.parent}`"></slot>
              </template>
              <template v-for="slotError in possibleChildSlotsFor('Error')" v-slot:[`${slotError.child}`]><slot :name="`${slotError.parent}`"></slot></template>
            </LabeledTextInput>
            <BirthdateInput
              :date.sync="person_.birthDate"
              :invalid.sync="invalid.birthDate"
              :checkForMinAge="18"
              ref="nestedInputBirthdate"
            >
              <template v-for="slot in possibleChildSlotsFor('BirthDate')" v-slot:[`${slot.child}`]>
                <slot :name="`${slot.parent}`"></slot>
              </template>
            </BirthdateInput>
          </div>
          <div class="form-row">
            <LabeledStreetInput
              name="street"
              :model.sync="address_.street"
              :invalid.sync="invalid.street"
              :validation="validations.address.street"
              :performAutocompleteForm="performAutocomplete"
              :mandatory="true"
              width="66"
              ref="nestedInputStreet"
              :inputAriaLabel="getSlotText('inputAriaLabelStreet')"
            >
              <template v-for="slot in possibleChildSlotsFor('Street')" v-slot:[`${slot.child}`]>
                <slot :name="`${slot.parent}`"></slot>
              </template>
              <template v-for="slotError in possibleChildSlotsFor('Error')" v-slot:[`${slotError.child}`]><slot :name="`${slotError.parent}`"></slot></template>
            </LabeledStreetInput>
            <LabeledTextInput
              name="houseNumber"
              :model.sync="address_.houseNumber"
              :invalid.sync="invalid.houseNumber"
              :mandatory="true"
              :validation="validations.address.houseNumber"
              width="33"
              ref="nestedInputHouseNumber"
            >
              <template v-for="slot in possibleChildSlotsFor('HouseNumber')" v-slot:[`${slot.child}`]>
                <slot :name="`${slot.parent}`"></slot>
              </template>
              <template v-for="slotError in possibleChildSlotsFor('Error')" v-slot:[`${slotError.child}`]><slot :name="`${slotError.parent}`"></slot></template>
            </LabeledTextInput>
          </div>
          <div class="form-row">
            <LabeledTextInput
              name="zip"
              :model.sync="address_.zip"
              :invalid.sync="invalid.zip"
              :validation="validations.address.zip"
              :formatter="zipFormatter()"
              :mandatory="true"
              width="33"
              ref="nestedInputZip"
            >
              <template v-for="slot in possibleChildSlotsFor('Zip')" v-slot:[`${slot.child}`]>
                <slot :name="`${slot.parent}`"></slot>
              </template>
              <template v-for="slotError in possibleChildSlotsFor('Error')" v-slot:[`${slotError.child}`]><slot :name="`${slotError.parent}`"></slot></template>
            </LabeledTextInput>
            <LabeledTextInput
              name="city"
              :model.sync="address_.city"
              :invalid.sync="invalid.city"
              :mandatory="true"
              :validation="validations.address.city"
              :formatter="formatterCharFilterOnlyAplha"
              width="66"
              ref="nestedInputCity"
            >
              <template v-for="slot in possibleChildSlotsFor('City')" v-slot:[`${slot.child}`]>
                <slot :name="`${slot.parent}`"></slot>
              </template>
              <template v-for="slotError in possibleChildSlotsFor('Error')" v-slot:[`${slotError.child}`]><slot :name="`${slotError.parent}`"></slot></template>
            </LabeledTextInput>
          </div>
          <div class="form-row">
            <LabeledTextInput
              name="supplement"
              :model.sync="address_.supplement"
              :invalid.sync="invalid.supplement"
              :validation="validations.address.supplement"
              :mandatory="false"
              ref="nestedInputSupplement"
            >
              <template v-for="slot in possibleChildSlotsFor('Supplement')" v-slot:[`${slot.child}`]>
                <slot :name="`${slot.parent}`"></slot>
              </template>
              <template v-for="slotError in possibleChildSlotsFor('Error')" v-slot:[`${slotError.child}`]><slot :name="`${slotError.parent}`"></slot></template>
            </LabeledTextInput>
          </div>
        </div>
        <div class="form--block" v-if="isMNPOrder">
          <LabeledCustomSwitch name="switchContractHolder" :value.sync="contractHolder_.active" @clicked="handleContractHolderSwitch" :ariaLabelActive="getSlotText('lblContractHolderSwitchActiveAriaLabel')" :ariaLabelInactive="getSlotText('lblContractHolderSwitchInactiveAriaLabel')">
            <template #lbl><slot name="lblContractHolderSwitch"></slot></template>
          </LabeledCustomSwitch>
          <div aria-live="polite">
            <div v-if="contractHolder_.active">
              <div class="card card--info"><slot name="txtContractHolder">Lorem ipsum dolor sit amet consectetur adipisicing elit. Similique aspernatur illo quos pariatur commodi ipsum fugit dolorum soluta qui earum.</slot></div>
            </div>
          </div>
          <div v-if="contractHolder_.active">
            <h2 class="h3"><slot name="lblContractHolderHeadline">Lorem ipsum dolor sit amet.</slot></h2>
            <div class="form-row">
              <LabeledTextInput
                name="contractHolderFirstName"
                :model.sync="contractHolder_.firstName"
                :invalid.sync="invalid.contractHolderFirstName"
                :validation="validations.contractHolder.firstName"
                :formatter="formatterCharFilterOnlyAplha"
                :mandatory="true"
                width="33"
                ref="nestedContractHolderInputFirstName"
              >
                <template v-for="slot in possibleChildSlotsFor('ContractHolderFirstName')" v-slot:[`${slot.child}`]>
                  <slot :name="`${slot.parent}`"></slot>
                </template>
                <template v-for="slotError in possibleChildSlotsFor('Error')" v-slot:[`${slotError.child}`]><slot :name="`${slotError.parent}`"></slot></template>
              </LabeledTextInput>
              <LabeledTextInput
                name="contractHolderLastName"
                :model.sync="contractHolder_.lastName"
                :invalid.sync="invalid.contractHolderLastName"
                :mandatory="true"
                :validation="validations.contractHolder.lastName"
                :formatter="formatterCharFilterOnlyAplha"
                width="33"
                ref="nestedContractHolderInputLastName"
              >
                <template v-for="slot in possibleChildSlotsFor('ContractHolderLastName')" v-slot:[`${slot.child}`]>
                  <slot :name="`${slot.parent}`"></slot>
                </template>
                <template v-for="slotError in possibleChildSlotsFor('Error')" v-slot:[`${slotError.child}`]><slot :name="`${slotError.parent}`"></slot></template>
              </LabeledTextInput>
              <BirthdateInput
                name="contractHolderBirthDate"
                :date.sync="contractHolder_.birthDate"
                :invalid.sync="invalid.contractHolderBirthDate"
                ref="nestedContractHolderInputBirthdate"
              >
                <template v-for="slot in possibleChildSlotsFor('ContractHolderBirthDate')" v-slot:[`${slot.child}`]>
                  <slot :name="`${slot.parent}`"></slot>
                </template>
              </BirthdateInput>
            </div>
          </div>
        </div>
        <div class="form--block">
          <h2 class="h3"><slot name="lblContactHeadline">Lorem ipsum dolor sit amet.</slot></h2>
          <div class="form-row">
            <LabeledTextInput
              name="email"
              :model.sync="person_.email"
              :invalid.sync="invalid.email"
              :validation="validations.person.email"
              :mandatory="true"
              ref="nestedInputEmail"
            >
              <template v-for="slot in possibleChildSlotsFor('Email')" v-slot:[`${slot.child}`]>
                <slot :name="`${slot.parent}`"></slot>
              </template>
              <template v-for="slotError in possibleChildSlotsFor('Error')" v-slot:[`${slotError.child}`]><slot :name="`${slotError.parent}`"></slot></template>
            </LabeledTextInput>
          </div>
          <div class="form-row">
            <LabeledTextInput
              name="repeatEmail"
              :model.sync="person_.repeatEmail"
              :invalid.sync="invalid.repeatEmail"
              :validation="validations.person.repeatEmail"
              :mandatory="true"
              ref="nestedInputRepeatEmail"
            >
              <template v-for="slot in possibleChildSlotsFor('RepeatEmail')" v-slot:[`${slot.child}`]>
                <slot :name="`${slot.parent}`"></slot>
              </template>
              <template v-for="slotError in possibleChildSlotsFor('Error')" v-slot:[`${slotError.child}`]><slot :name="`${slotError.parent}`"></slot></template>
            </LabeledTextInput>
          </div>
          <div class="form-row">
            <LabeledPhoneNumberInput
              :model.sync="person_.phone"
              :invalid.sync="invalid.phone"
              ref="nestedInputPhone"
            >
              <template v-for="slot in possibleChildSlotsFor('Phone')" v-slot:[`${slot.parent}`]>
                <slot :name="`${slot.parent}`"></slot>
              </template>
              <template v-for="slotError in possibleChildSlotsFor('Error')" v-slot:[`${slotError.parent}`]>
                <slot :name="`${slotError.parent}`"></slot>
              </template>
            </LabeledPhoneNumberInput>
          </div>
          <div class="privilege-terms" v-html="privilegeTerms"></div>
          <div class="card card--info" v-if="this.isMNPOrder">
            <LabeledCheckbox
              name="contractHolderConfirmation"
              :model.sync="contractHolder_.confirmation"
              :invalid.sync="invalid.contractHolderConfirmation"
              :mandatory="true"
              ref="nestedInputConfirmation"
            >
              <template v-for="slot in possibleChildSlotsFor('ContractHolderConfirmation')" v-slot:[`${slot.child}`]>
                <slot :name="`${slot.parent}`"></slot>
              </template>
              <template v-for="slotError in possibleChildSlotsFor('Error')" v-slot:[`${slotError.child}`]><slot :name="`${slotError.parent}`"></slot></template>
            </LabeledCheckbox>
          </div>
        </div>
      </b-form>
    </div>
    <Stepper
      :loading-next="loading"
      :show-prev="true"
      @prev="$emit('goBack')"
      @next="save()"
      :ariaLabelNext="getSlotText('btnNextAriaLabel')"
    >
      <template v-for="slot in possibleChildSlotsFor('Stepper')" v-slot:[`${slot.child}`]>
        <slot :name="`${slot.parent}`"></slot>
      </template>
    </Stepper>
  </div>
</template>

<script>
import LabeledTextInput from '@/components/forms/LabeledTextInput.vue'
import LabeledStreetInput from '@/components/forms/LabeledStreetInput.vue'
import LabeledCustomSwitch from '@/components/forms/LabeledCustomSwitch.vue'
import LabeledCheckbox from '@/components/forms/LabeledCheckbox.vue'
import GenderRadioInput from '@/components/forms/GenderRadioInput.vue'
import emailValidator from '@/mixins/validators/emailValidator'
import houseNumberValidator from '@/mixins/validators/houseNumberValidator'
import Stepper from '@/components/generic/Stepper.vue'
import preFilledObjectInput from '@/mixins/preFilledObjectInput'
import validationFlow from '@/mixins/validators/validationFlow'
import formatterCharFilterOnlyAplha from '@/mixins/formatters/inputFormatter'
import formatDecimal from '@/mixins/formatters/formatDecimal'
import { maxLength, required } from 'vuelidate/lib/validators'
import transaction from '@/mixins/transaction'
import BirthdateInput from '@/components/forms/LabeledBirthdateInput.vue'
import LabeledPhoneNumberInput from '@/components/forms/LabeledPhoneNumberInput.vue'
import trackingHandler from '@/mixins/trackingHandler'

export default {
  name: 'CheckoutCustomerData',
  components: {
    LabeledPhoneNumberInput,
    GenderRadioInput,
    BirthdateInput,
    LabeledTextInput,
    LabeledStreetInput,
    LabeledCustomSwitch,
    LabeledCheckbox,
    Stepper
  },
  mixins: [
    emailValidator,
    houseNumberValidator,
    preFilledObjectInput('person', 'getPerson'),
    preFilledObjectInput('address', 'getAddress'),
    preFilledObjectInput('contractHolder', 'getContractHolder'),
    validationFlow,
    formatterCharFilterOnlyAplha,
    formatDecimal,
    transaction('customerDataValidation'),
    trackingHandler
  ],
  props: {
    process: {
      type: String,
      default: 'ordering'
    }
  },
  data () {
    return {
      loading: false,
      invalid: {
        gender: null,
        firstName: null,
        lastName: null,
        birthDate: null,
        street: null,
        houseNumber: null,
        zip: null,
        city: null,
        supplement: null,
        email: null,
        repeatEmail: null,
        phone: null,
        contractHolderFirstName: null,
        contractHolderLastName: null,
        contractHolderBirthDate: null,
        contractHolderConfirmation: null
      },
      validations: {
        person: {
          firstName: {
            required,
            maxLength: maxLength(50)
          },
          lastName: {
            required,
            maxLength: maxLength(50)
          },
          email: {
            required,
            email: (v) => {
              return this.validateEmail(v.toLowerCase())
            }
          },
          repeatEmail: {
            required,
            repeatEmail: (v) => {
              return v === this.person.email
            }
          }
        },
        address: {
          street: {
            required,
            maxLength: maxLength(50)
          },
          houseNumber: {
            required,
            maxLength: maxLength(9),
            houseNumber: (v) => {
              return this.houseNumberValidator(v)
            }
          },
          zip: {
            required,
            maxLength: maxLength(5),
            zip: (v) => {
              const validator = /^\d{5}$/
              return validator.test(v)
            }
          },
          city: {
            required,
            maxLength: maxLength(50)
          },
          supplement: {
            maxLength: maxLength(50)
          }
        },
        contractHolder: {
          firstName: {
            required,
            maxLength: maxLength(50)
          },
          lastName: {
            required,
            maxLength: maxLength(50)
          }
        }
      }
    }
  },
  watch: { },
  methods: {
    save () {
      this.forceValidationOnNestedInputs()
      if (!this.formInvalid) {
        // Store ContractHolder if used
        if (this.contractHolder_.active) {
          this.$store.commit('checkoutv2/' + this.process + '/_mnpData/setContractHolder', this.contractHolder_)
        }
        this.startLoader()
        this.loading = true

        this.$store
          .dispatch('checkoutv2/' + this.process + '/_customerData/validate', {
            person: this.person_,
            address: this.address_,
            process: this.process
          })
          .then(() => {
            this.$emit('goForward')
          })
          .catch((error) => {
            this.errorToast(this.getErrorMessage(error))
            this.triggerErrorTracking(error)
          })
          .finally(() => {
            this.loading = false
            // Use Callback to ensure that the focus is set on next step after the loader is hidden
            this.stopLoader(() => {
              this.findAndSetFocusManually()
            })
          })
      } else {
        // ensure live feedback for validation errors
        this.vFlowScrollToFirstElemment()
        const _this = this
        this.vFlowGetFirstErrorElementName().then(function (result) {
          _this.triggerValidationErrorTracking(result)
        })
      }
    },
    forceValidationOnNestedInputs () {
      Object.entries(this.$refs).forEach(([key, comp]) => {
        if (/^nestedInput/.test(key) && comp !== undefined) {
          comp.vflowForceFeedback()
        }
      })
      if (this.contractHolder_.active) {
        Object.entries(this.$refs).forEach(([key, comp]) => {
          if (/^nestedContractHolderInput/.test(key) && comp !== undefined) {
            comp.vflowForceFeedback()
          }
        })
      }
    },
    zipFormatter () {
      return (v) => v.replace(/[^\d]/g, '').substring(0, 5)
    },
    handleContractHolderSwitch (event) {
      if (!event.active) {
        this.contractHolder_.active = false
        this.$store.commit('checkoutv2/' + this.process + '/_mnpData/setContractHolder', this.contractHolder_)
        Object.entries(this.$refs).forEach(([key, comp]) => {
          if (/^nestedContractHolderInput/.test(key)) {
            comp.vflowResetFeedbackStates()
          }
        })
        this.invalid.contractHolderFirstName = null
        this.invalid.contractHolderLastName = null
        this.invalid.contractHolderBirthDate = null
      } else {
        const data = {
          information_action: 'reveal',
          information_name: 'previous contract data',
          information_ui_type: 'panel',
          information_trigger: 'checkbox'
        }
        this.trackData('information', data)
      }
    },
    performAutocomplete (place) {
      this.address_.zip = ''
      this.address_.houseNumber = ''
      this.address_.city = ''
      this.address_.street = ''
      // const place = this.autocompleteHandler.getPlace()
      // Get each component of the address from the place details,
      // and then fill-in the corresponding field on the form.
      // place.address_components are google.maps.GeocoderAddressComponent objects
      // which are documented at http://goo.gle/3l5i5Mr
      if (place.address_components === undefined || place.address_components.length <= 0) {
        this.errorToast(this.getSlotText('txtGoogleAutocompleteError'))
        return
      }
      for (const component of place.address_components) {
        const componentType = component.types[0]

        switch (componentType) {
          case 'street_number': {
            this.address_.houseNumber = component.long_name
            break
          }
          case 'postal_code': {
            this.address_.zip = component.long_name
            break
          }
          case 'locality': {
            this.address_.city = component.long_name
            break
          }
          case 'route': {
            // Add short delay on rout to avoid race conditions with google autocomplete
            const _this = this
            setTimeout(() => { _this.address_.street = component.long_name }, 5)
            break
          }
        }
      }
      if (this.address_.houseNumber === '') {
        document.getElementById('houseNumber').focus()
      } else if (this.address_.zip === '') {
        document.getElementById('zip').focus()
      }
    },
    findAndSetFocusManually () {
      const targetStepName = this.getCurrentStepName
      const targetStepLi = document.querySelector(`li.${targetStepName}`)

      if (targetStepLi) {
        // Find the button
        const targetButton = targetStepLi.querySelector("[role='button']")

        if (targetButton) {
          targetButton.setAttribute('tabindex', '0') // make it focusable
          targetButton.focus()
        }
      }
    }
  },
  computed: {
    isMNPOrder () {
      return this.$store.getters['checkoutv2/' + this.process + '/_mnpData/active'] === true
    },
    getContractHolder () {
      return this.$store.getters['checkoutv2/' + this.process + '/_mnpData/contractHolder']
    },
    getPerson () {
      return this.$store.getters['checkoutv2/' + this.process + '/_customerData/person']
    },
    getAddress () {
      return this.$store.getters['checkoutv2/' + this.process + '/_customerData/address']
    },
    privilegeTerms: function () {
      if (window.$gqlpre && typeof window.$gqlpre.brandConsents !== 'undefined') {
        return window.$gqlpre.brandConsents.consents.find(item => item.name === 'privilege_terms')?.text || ''
      }
      return ''
    },
    formInvalid: function () {
      return Object.entries(this.invalid)
        .map(([key, value]) => value)
        .some((value) => value === true)
    },
    getCurrentStepName: function () {
      return this.$store.getters['checkoutv2/' + this.process + '/step']
    }
  }
}
</script>
